<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="mat-typography">
    <div class="brands-view">
        <p>This feature is only available on the Hobbyist plan.</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
        class="add-btn" (click)="goToSubscription()"><span
            style="line-height: 24px;margin-right: 5px;display: inline-block;">Goto Subscriptions</span></button>
</mat-dialog-actions>